<cv-loader [size]="'large'" [overlay]="false" *ngIf="broadcast == null"></cv-loader>
<div [ngStyle]="{ 'height': 'calc(100% - ' + readHeight() + ')' }" *ngIf="broadcast != null">
    <overlay-scrollbars class="h-100" [options]="scrollOptions">
    <div class="d-flex position-absolute" [ngStyle]="{ 'right': moduleKey == null ? '3px' : '8px'}" *ngIf="broadcast.BroadcastType == 0">
        <svg class="icon-16 fill-redRyder" *ngIf="broadcast.Urgent">
            <use href="../App_Themes/clearview-default/icons/utility/urgent.svg#urgent"></use>
        </svg>
        <div class="ml-1 position-relative clickable" style="top:-4px" (click)="toggleFavorite()" *ngIf="moduleKey != null">
            <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail" *ngIf="!broadcast.Favorite">
                <use href="../App_Themes/clearview-default/icons/utility/favorite.svg#favorite"></use>
            </svg>
            <svg class="icon-16 fill-midas fill-hover-midasHover" *ngIf="broadcast.Favorite">
                <use href="../App_Themes/clearview-default/icons/utility/favorite-filled.svg#favorite-filled"></use>
            </svg>
        </div>
    </div>
    <div class="mt-2 position-absolute" style="width:65px; height:65px" [ngClass]="{ announcementsGeneralIcon: broadcast.AnnouncementType == 0,
        announcementsPartyIcon: broadcast.AnnouncementType == 1, announcementsDateEventIcon: broadcast.AnnouncementType == 2, announcementsIncentiveIcon: broadcast.AnnouncementType == 3 }"
        *ngIf="broadcast.BroadcastType == 1" [ngStyle]="{ 'right': moduleKey == null ? '0px' : '16px' }">
        <div class="announcementsUrgentCircle position-absolute" *ngIf="broadcast.Urgent"></div>
    </div>
    <div class="lato-bold color-theUpsideDown font-size-18 mb-2">{{broadcast.Title}}</div>
    <div class="font-size-12" *ngIf="moduleKey != null && broadcast.BroadcastType == 1">
        <span cvLocalizedText langSection="Broadcasts" langKey="Sent">Sent</span>: {{getRelativeTime(broadcast.DateCreated, broadcast.DateCreated_UTC)}}
    </div>
    <div class="font-size-12">
        <span cvLocalizedText langSection="Broadcasts" langKey="From">From</span>: 
        <span *ngIf="!extraLoading">{{broadcast.CreatedBy}}</span>
        <span *ngIf="extraLoading">...</span>
        <span class="position-absolute" style="right:5px" *ngIf="broadcast.BroadcastType == 0">{{broadcast.DateCreated | date: cvAngularDateFormat}}</span>
    </div>
    <div class="font-size-12" *ngIf="broadcast.BroadcastType == 1 && broadcast.AnnouncementType == 2">
        <span cvLocalizedText langSection="Broadcasts" langKey="Event_Date">Event Date</span>: {{broadcast.EventDate | date: cvAngularDateFormat}}
    </div>
    <div class="font-size-12 pb-2" *ngIf="showDetails">
        <div>
            <span cvLocalizedText langSection="Broadcasts" langKey="To">To</span>: 
            <span *ngIf="(!broadcast.ShowAllRecips || !(numberOfRoles() > 1)) && !extraLoading">
                {{roleName(0)}} ({{recipientsInRole(0)}})
                <span *ngIf="numberOfRoles() > 1">
                 ...<span class="color-cerulean ml-1 clickable" (click)="broadcast.ShowAllRecips = true">+ {{recipientsInAllOtherRoles()}} <span cvLocalizedText langSection="Broadcasts"
                    langKey="More">more</span></span>
                </span>
            </span>
            <span *ngIf="broadcast.ShowAllRecips && numberOfRoles() > 1 && !extraLoading">
                <span>{{broadcast.RoleCountString}}</span>
            <span class="color-cerulean ml-1 clickable" (click)="broadcast.ShowAllRecips = false" cvLocalizedText langSection="Broadcasts" langKey="Less">less</span>
            </span>
            <span *ngIf="extraLoading">...</span>
        </div>
        <div *ngIf="broadcast.ExpirationDate != null">
            <span *ngIf="broadcastHasNotExpired()" cvLocalizedText langSection="Broadcasts" langKey="Expires_On">Expires on</span>
        <span *ngIf="!broadcastHasNotExpired()" cvLocalizedText langSection="Broadcasts" langKey="Expired_On">Expired on</span>
        : {{broadcast.ExpirationDate | date: cvAngularDateFormat}}
        </div>
        <div><span cvLocalizedText langSection="Broadcasts" langKey="Folder">Folder</span>: {{broadcast.Folder}}</div>
        <div *ngIf="broadcast && broadcast.Tags && broadcast.Tags.length > 0"><span cvLocalizedText langSection="Broadcasts" langKey="Tags">Tags</span>: {{broadcast.TagString}}</div>
        <div *ngIf="moduleKey == null && broadcast.FormID != null">
            <span cvLocalizedText langSection="Broadcasts" langKey="Survey_Quiz">Survey/Quiz</span>: 
            <span *ngIf="!extraLoading">{{broadcast.Quiz}}</span>
            <span *ngIf="extraLoading">...</span>
        </div>
    </div>
    <div class="color-cerulean font-size-11 mb-3 d-inline-block clickable" *ngIf="!showDetails" (click)="showDetails = true"
        cvLocalizedText langSection="Broadcasts" langKey="Show_Details">Show details</div>
    <div class="color-cerulean font-size-11 mb-3 d-inline-block clickable" *ngIf="showDetails" (click)="showDetails = false"
        cvLocalizedText langSection="Broadcasts" langKey="Hide_Details">Hide details</div>
    <div *ngFor="let attachment of broadcast.Attachments">
        <a href="{{'../Admin/FileViewer.aspx?fid=' + attachment.AttachmentID + '&ft=1&ofn=' + attachment.AttachmentName + '&ofe=' + attachment.AttachmentExtension}}">
            <svg class="icon-16 fill-valyrianSteel">
                <use href="../App_Themes/clearview-default/icons/utility/attachment.svg#attachment"></use>
            </svg>
        <span class="color-cerulean">{{attachment.AttachmentName}}.{{attachment.AttachmentExtension}}</span>
        </a>
    </div>
    <div class="d-flex flex-wrap justify-content-center" style="padding-top:14px">
        <div class="font-size-12 rounded shadow-sm p-2 border mx-2 mb-3 position-relative" style="height:142px; width:365px; padding-bottom:6px !important"
            *ngFor="let hyperlink of broadcast.Hyperlinks">
            <a class="text-truncate d-inline-block pb-1 mw-100" href="{{hyperlink.HyperlinkAddress}}" target="_blank">
                {{hyperlink.HyperlinkAddress}}
            </a>
            <div class="d-flex">
                <a class="mr-2" [href]="hyperlink.HyperlinkAddress" target="_blank" style="text-decoration: none;">
                    <div *ngIf="hyperlink.ContentSecurityPolicyViolation || hyperlink.IframeAvailability !=0" class="d-flex justify-content-center align-items-center border">
                        <div class="d-flex flex-column align-items-center justify-content-center" style="width: calc(880px * 0.2); height: calc(490px * 0.2); opacity: 1; border: 1px solid #d2d6db; border-radius:3px">
                            <div>
                                <svg class="icon-32 fill-valyrianSteel fill-hover-whaleTail" style="pointer-events:none; cursor:default;">
                                    <use href="../App_Themes/clearview-default/icons/utility/image.svg#image"></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!hyperlink.ContentSecurityPolicyViolation && hyperlink.IframeAvailability == 0" class="d-flex justify-content-center align-items-center border" style="width: calc(880px * 0.2); height: calc(490px * 0.2);">
                        <div class="websiteModulePreview position-relative w-100 h-100">
                            <iframe [src]="hyperlink.HyperlinkAddress | safeUrl" style="width: 880px; height: 490px; pointer-events: none; opacity: 1;" frameborder="0" sandbox="" scrolling="no"></iframe>
                        </div>
                    </div>
                </a>
            <overlay-scrollbars [options]="scrollOptions">
                <div style="width:163px; height:97px">{{hyperlink.HyperlinkText}}</div>
            </overlay-scrollbars>
            </div>
        </div>
        <div class="font-size-12 d-flex rounded shadow-sm p-2 border mx-2 mb-3 position-relative" style="width:365px" *ngFor="let video of broadcast.Videos; index as i">
            <div class="mr-2 position-relative clickable" (click)="openPlayer(video)">
                <img style="width:176px; height:98px; object-fit:cover" [src]="broadcast.VideoInfo[i]?.thumbnails.high.url" />
                <div class="workAidsVideoIcon position-absolute"></div>
                <div class="rounded color-greekToMe position-absolute px-1" style="bottom:4px; right:4px; background-color:rgba(0, 0, 0, 0.7)">{{broadcast.VideoInfo[i]?.duration}}</div>
            </div>
            <div class="overflow-auto" style="width:163px; height:98px">
                <overlay-scrollbars class="h-100" [options]="scrollOptions">
                <div class="lato-bold">
                    <a href="https://www.youtube.com/watch?v={{video}}" target="_blank">{{broadcast.VideoInfo[i]?.title}}</a>
                </div>
                <div>
                    <a href="https://www.youtube.com/channel/{{broadcast.VideoInfo[i]?.channelId}}" target="_blank">{{broadcast.VideoInfo[i]?.channelTitle}}</a>
                </div>
            </overlay-scrollbars>
            </div>
        </div>
    </div>
    <div class="mb-2" [innerHTML]="trustAsHtml(broadcast.BroadcastText)"></div>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="font-size-12 rounded shadow-sm d-flex justify-content-center p-2 border mx-2 mb-3 position-relative" style="width:365px"
            *ngFor="let image of broadcast.Images; index as i">
            <img [src]="'../Admin/FileViewer.aspx?iid=' + image.ImageID + '&ofn=' + image.AltText + '&ofe=' + image.FileExtension"
                class="clickable" style="max-height:136px; max-width:270px;" (click)="selectImageForViewer(broadcast.Images, i)" />
        </div>
    </div>
</overlay-scrollbars>
</div>
<div class="position-relative" style="width:calc(100% + 16px); box-shadow:0px -3px 6px #D2D6DB; left:-8px" [ngStyle]="{ 'height': readHeight() }" *ngIf="readable">
    <div class="h-100 d-flex justify-content-center" *ngIf="broadcast.Read">
        <div class="color-theUpsideDown font-size-12 align-self-center" cvLocalizedText langSection="Broadcasts" langKey="Post_Acknowledge_Messsage">You have acknowledged you have reviewed this content.</div>
    </div>
    <div class="h-100 d-flex justify-content-between" *ngIf="!broadcast.Read && broadcast.FormID == null">
        <div class="color-theUpsideDown font-size-12 align-self-center ml-2" cvLocalizedText langSection="Broadcasts" langKey="Pre_Acknowledge_Message">Acknowledge you have reviewed this content.</div>
        <button type="button" class="btn btn-primary mt-2 mr-2" (click)="setAsRead()" cvLocalizedText langSection="Broadcasts" langKey="Acknowledge">Acknowledge</button>
    </div>
    <div class="h-100 d-flex justify-content-between" *ngIf="!broadcast.Read && broadcast.FormID != null">
        <div class="color-theUpsideDown font-size-12 align-self-center ml-2" cvLocalizedText langSection="Broadcasts" langKey="Quiz_Prompt">Take attached survey/quiz.</div>
        <button type="button" class="btn btn-primary mt-2 mr-2" (click)="quizPopupOpen = true" cvLocalizedText langSection="Broadcasts" langKey="Quiz_Button">Take Survey/Quiz</button>
    </div>
</div>
<div class="w-100 h-100 fixed-top bg-whaleTail" style="opacity:0.6; z-index:999" (click)="imageViewerArray = null; quizPopupClose()"
    *ngIf="imageViewerArray != null || videoPlayerOpen || quizPopupOpen"></div>
<div class="broadcastPopupWindow bg-white rounded shadow d-flex align-items-center px-2 mx-auto position-fixed" style="height:auto; width:auto; padding-top:20px; padding-bottom:20px"
    *ngIf="imageViewerArray != null">
    <button type="button" class="broadcastPopupCloseBtn icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" (click)="imageViewerArray = null">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="selectImageForViewer(imageViewerArray, imageViewerIndex-1)"
        [attr.disabled]="imageViewerIndex <= 0">
        <svg class="icon-24">
            <use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use>
        </svg>
    </button>
    <a href="{{'../Admin/FileViewer.aspx?iid=' + imageViewerImage.ImageID + '&ofn=' + imageViewerImage.AltText + '&ofe=' + imageViewerImage.FileExtension}}" target="_blank">
        <img [src]="'../Admin/FileViewer.aspx?iid=' + imageViewerImage.ImageID + '&ofn=' + imageViewerImage.AltText + '&ofe=' + imageViewerImage.FileExtension"
            style="max-height:65vh; max-width:65vw" />
    </a>
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="selectImageForViewer(imageViewerArray, imageViewerIndex+1)"
        [attr.disabled]="imageViewerIndex == imageViewerArray.length-1">
        <svg class="icon-24">
            <use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use>
        </svg>
    </button>
</div>
<div class="broadcastPopupWindow bg-white rounded shadow mx-auto position-fixed broadcastVideoPlayerPopup py-4" [hidden]="!videoPlayerOpen">
    <button type="button" class="broadcastPopupCloseBtn icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" (click)="videoPlayerClose()">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
    <div id="{{'VideoPlayerDirective' + (broadcastId != null ? broadcastId : '') + (moduleKey != null ? moduleKey : '')}}"></div>
</div>
<div class="broadcastPopupWindow bg-white rounded p-4 mx-auto position-fixed" style="height:calc(65% + 18px)" *ngIf="quizPopupOpen">
    <button type="button" class="broadcastPopupCloseBtn icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" (click)="quizPopupClose()">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
    <div class="position-relative" style="height:calc(100% - 70px)">
    </div>
    <div class="d-flex justify-content-between position-absolute" style="width:calc(100% - 40px); bottom:12px">
        <div class="color-redRyder">{{quizError}}</div>
        <button type="button" class="btn btn-primary" (click)="submitAnswers()" cvLocalizedText langSection="Broadcasts" langKey="Submit_Answers">Submit Answers</button>
    </div>
</div>
<div class="w-100 h-100 fixed-top bg-whaleTail" style="opacity:0.6; z-index:1001" *ngIf="progressPopupOpen"></div>
<div class="broadcastPopupWindow bg-white rounded shadow p-0 mx-auto position-fixed" style="height:300px; width:300px; z-index:1002" *ngIf="progressPopupOpen">
    <cv-loader [size]="'large'" [overlay]="false"></cv-loader>
</div>
